import React, { useMemo, useState } from 'react';
import { Card, Form, Row, Col, Alert } from 'react-bootstrap';

export default function RoiCalculator() {
  const [monthlyDispatches, setMonthlyDispatches] = useState(40);
  const [costPerDispatch, setCostPerDispatch] = useState(75);
  const [avoidablePct, setAvoidablePct] = useState(25);
  const [sessionsPerMonth, setSessionsPerMonth] = useState(30);
  const [creditCost, setCreditCost] = useState(15);

  const result = useMemo(() => {
    const avoided = Math.round(monthlyDispatches * (avoidablePct / 100));
    const monthlySavings = avoided * costPerDispatch;
    const sessionCost = sessionsPerMonth * creditCost;
    const net = monthlySavings - sessionCost;
    const roi = sessionCost > 0 ? Math.round((net / sessionCost) * 100) : 0;
    const annualNet = net * 12;

    return { avoided, monthlySavings, sessionCost, net, roi, annualNet };
  }, [monthlyDispatches, costPerDispatch, avoidablePct, sessionsPerMonth, creditCost]);

  return (
    <Card className="border-0 shadow-sm mb-4 roi-calculator">
      <Card.Body className="p-4">
        <h2 className="h5 fw-bold mb-3">Calculateur ROI (estimation)</h2>
        <p className="text-secondary small mb-4">
          Estimez le retour mensuel en comparant les déplacements évités au coût des sessions
          Assistance Video (1 crédit = 1 session, packs sans abonnement).
        </p>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Déplacements / mois</Form.Label>
              <Form.Control
                type="number"
                min={0}
                value={monthlyDispatches}
                onChange={(e) => setMonthlyDispatches(Number(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Coût moyen d&apos;un déplacement (€)</Form.Label>
              <Form.Control
                type="number"
                min={0}
                value={costPerDispatch}
                onChange={(e) => setCostPerDispatch(Number(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Part éligible à la vidéo (%)</Form.Label>
              <Form.Control
                type="number"
                min={0}
                max={100}
                value={avoidablePct}
                onChange={(e) => setAvoidablePct(Number(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Sessions vidéo / mois</Form.Label>
              <Form.Control
                type="number"
                min={0}
                value={sessionsPerMonth}
                onChange={(e) => setSessionsPerMonth(Number(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Coût moyen d&apos;un crédit (€)</Form.Label>
              <Form.Control
                type="number"
                min={0}
                value={creditCost}
                onChange={(e) => setCreditCost(Number(e.target.value) || 0)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Alert variant={result.net >= 0 ? 'success' : 'warning'} className="mt-4 mb-0">
          <div>
            <strong>Déplacements évités estimés :</strong> {result.avoided} / mois
          </div>
          <div>
            <strong>Économies brutes :</strong> {result.monthlySavings.toLocaleString('fr-FR')} € / mois
          </div>
          <div>
            <strong>Coût sessions :</strong> {result.sessionCost.toLocaleString('fr-FR')} € / mois
          </div>
          <div>
            <strong>Gain net :</strong> {result.net.toLocaleString('fr-FR')} € / mois (
            {result.annualNet.toLocaleString('fr-FR')} € / an)
          </div>
          <div>
            <strong>ROI estimé :</strong> {result.roi} %
          </div>
        </Alert>
      </Card.Body>
    </Card>
  );
}
